/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceId } from "../../commons/types/SpaceId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { SheetConfigOrUpdate } from "../../sheets/types/SheetConfigOrUpdate";
import { Action } from "../../commons/types/Action";
import { WorkbookConfigSettings } from "./WorkbookConfigSettings";
export const WorkbookUpdate = core.serialization.object({
    name: core.serialization.string().optional(),
    labels: core.serialization.list(core.serialization.string()).optional(),
    spaceId: SpaceId.optional(),
    environmentId: EnvironmentId.optional(),
    namespace: core.serialization.string().optional(),
    sheets: core.serialization.list(SheetConfigOrUpdate).optional(),
    actions: core.serialization.list(Action).optional(),
    metadata: core.serialization.any().optional(),
    settings: WorkbookConfigSettings.optional(),
    folder: core.serialization.string().optional(),
});
